import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";
import "tippy.js/animations/scale.css";
import "tippy.js/dist/tippy.css";

export default class extends Controller {
  static values = {
    label: String,
    placement: String,
  };

  connect() {
    if (this.hasLabelValue && this.labelValue.length > 0) {
      tippy(this.element, {
        content: this.labelValue,
        placement: this.placementValue || "top",
        animation: "scale",
        arrow: true,
        delay: 100,
      });
    }
  }
}
